import React from 'react';
import {PillType} from "./PillTypes";


const Pill = (props: PillType) => {
	return (
		<div title={props.title} className={`pill ${props.colour ? props.colour : ''} ${props.size ? props.size : 'pill-md'}`}>
			{props.content}
		</div>
	);
};

export default Pill;
